import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '../monitoring/error-boundary';
import { QueueStateProvider } from '../queues/context/queue-state-provider';
import { FrPage } from '../fr-page-layout/fr-page';
import { FrEventsList } from './fr-events-list';
import { FrSharedQueueFiltersContextProvider } from './state/fr-shared-queue-filters-context';
import { useWorkspaceStore } from '../panels/use-workspace-store';
import { EntityTypeEnum, WorkspaceWindowTypeEnum } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { assertNonNull } from '../queues/utils/assert-non-null';
import { FrBoloQueueStoreProvider } from './fr-bolo-queue-store-provider';

export const FrEventsListPage = observer(function FrEventsListPage() {
    const navigate = useNavigate();

    const workspacePanels = useWorkspaceStore().activePanels;

    const foundEventQueueWorkspacePanel = workspacePanels.find(
        (panel) =>
            panel.workspacePanelType === WorkspaceWindowTypeEnum.QUEUE.name &&
            panel.queue?.dataEntityType === EntityTypeEnum.CAD_AGENCY_EVENT.name
    );

    assertNonNull(
        foundEventQueueWorkspacePanel,
        'Unexpectedly did not find WorkspaceQueue with dataEntityType=CAD_AGENCY_EVENT'
    );
    return (
        <FrPage>
            <ErrorBoundary
                name="FR_EVENTS_LIST_PAGE"
                actions={[{ children: 'Close', onClick: () => navigate('/') }]}
            >
                <FrBoloQueueStoreProvider>
                    <QueueStateProvider workspacePanel={foundEventQueueWorkspacePanel}>
                        <FrSharedQueueFiltersContextProvider>
                            <FrEventsList />
                        </FrSharedQueueFiltersContextProvider>
                    </QueueStateProvider>
                </FrBoloQueueStoreProvider>
            </ErrorBoundary>
        </FrPage>
    );
});
